<div class="col layout-row"
     [ngClass]="{'selected': isSelected, 'locked': route.locked || isRunning, 'full-height': !isCollapsed, 'collapsed': isCollapsed}"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)">

  <div class="drag-wrapper" (click)="$event.stopPropagation();">
    <ng-content></ng-content>
  </div>

  <div class="route-left-bar layout-column layout-align-center-center gap-5">
    <bringoz-button *ngIf="(!route.locked || isHover) && !isCollapsed"
                    [appBringozIdGenerator]="canClose ? 'lock-route-route-drill-down' : 'lock-route-routes-panel'"
                    type="tertiary"
                    size="fit"
                    (onClick)="onToggleLocked();$event.stopPropagation();">
      <bringoz-icon [iconName]="route.locked ? 'lock' : 'lock-open-outline'" classSize="lg"
                    fill="#484848"></bringoz-icon>
    </bringoz-button>
    <div class="index-border" [style.background-color]="routeColor"></div>
    <bringoz-button *ngIf="(!isVisible || isHover) && !isCollapsed"
                    appBringozIdGenerator="show-hide-route-routes-panel"
                    type="tertiary"
                    size="fit"
                    (onClick)="onToggleVisible.emit(!isVisible);$event.stopPropagation();">
      <bringoz-icon [iconName]="isVisible ? 'eye-on' : 'eye-off'" classSize="lg" fill="#484848"></bringoz-icon>
    </bringoz-button>
  </div>

  <div class="flex layout-column">

    <!--Link Row-->
    <div class="layout-row layout-align-start-center route-title full-width">

      <!-- Edit Resource Allocation Button -->
      <ng-container *ngIf="(!route.locked && !isRunning) && route.status !== 'DISPATCHED'">
        <bringoz-button type="tertiary"
                        appBringozIdGenerator="edit-route-routes-panel"
                        size="fit"
                        class="edit-resource-btn"
                        *ngxPermissionsOnly="'planning.update'"
                        (onClick)="onEditResourceAllocationClick($event);$event.stopPropagation()"
                        [ngbTooltip]="(route.locked || isRunning) ? ('Route is locked for editing' | translate) : ('Edit Resource Allocation' | translate)">
          <bringoz-icon iconName="edit-outline" classSize="sm" [fill]="(route.locked || isRunning) ? '#CCCCCC' : '#484848'"></bringoz-icon>
        </bringoz-button>
      </ng-container>

      <div class="flex layout-row">
        <app-bringoz-checkbox *ngIf="canSelect && route.status !== 'DISPATCHED'"
                              appBringozIdGenerator="checkbox-route-routes-panel"
                              [isChecked]="isSelected"
                              (clickEvent)="onToggle.emit(!isSelected);$event.stopPropagation()">
        </app-bringoz-checkbox>
        <div class="flex layout-row clickable gap-5"
             appBringozIdGenerator="edit-route-details-route-routes-panel"
             (click)="onChangeRouteResourceClick($event);$event.stopPropagation()">
          <span class="flex br-body-1 text-ellipsis"
                [appBringozTooltip]="(route.name ? route.name : 'Route' | translate) + ' - ' + (route.resource?.allocationName || route.resource?.vehicleName)"
                ngbTooltip>
          {{ route.name ? route.name : 'Route' | translate }} {{ route.resource?.allocationName || route.resource?.vehicleName }}
        </span>
          <span id="route-resource-arrow">▾</span>
        </div>

        <div *ngIf="settings?.columns?.jobsCount" class="layout-row layout-align-start-center gap-2">
          <span class="br-body-1">{{route.jobIds?.length === 1 ? ('X_SERVICE' | translate: {sum: route.jobIds.length}) : ('X_SERVICES' | translate: {sum: route.jobIds.length}) }}</span>
        </div>

<!--        <div *ngIf="settings?.columns?.activitiesCount" class="layout-row layout-align-start-center gap-2">-->
<!--          <bringoz-icon iconName="location-pin-outline" classSize="sm" fill="#484848"></bringoz-icon>-->
<!--          <span class="br-body-1">{{ route.totals?.totalStopsCount }}</span>-->
<!--        </div>-->
      </div>

      <div *ngIf="route.jobChangesSyncedAt" class="layout-row layout-align-start-center gap-2">
        <bringoz-icon iconName="synced"
                      classSize="md"
                      [ngbTooltip]="('Synced' | translate) + ': ' + (route | bringozFullDate: 'jobChangesSyncedAt') + ' ' + (route | bringozTime: 'jobChangesSyncedAt')"
                      openDelay="300">
        </bringoz-icon>
      </div>

      <app-planning-route-action-menu
        *ngIf="isShowActionMenu"
        [route]="route"
        (onDispatch)="onDispatch.emit($event)"
        (onReoptimize)="onReoptimize.emit($event)"
        (onPreAssignAgent)="onPreAssignAgent.emit($event)"
        (onPrint)="onPrint.emit($event)"
        (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
        (onDelete)="onDelete.emit($event)"
        (onFeedback)="onFeedback.emit($event)">
      </app-planning-route-action-menu>


      <div *ngIf="canClose" class="layout-row layout-align-center-center gap-0">
        <bringoz-button type="tertiary"
                        size="fit"
                        (onClick)="onToggleCollapse();$event.stopPropagation();">
          <bringoz-icon [iconName]="isCollapsed ? 'chevron-down' : 'chevron-up'" classSize="lg"
                        fill="#484848"></bringoz-icon>
        </bringoz-button>
        <bringoz-button type="tertiary"
                        size="fit"
                        [ngbTooltip]="'Back'"
                        (onClick)="onClose.emit();$event.stopPropagation()">
          <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
        </bringoz-button>
      </div>

    </div>


    <div class="flex layout-row layout-wrap"
         (click)="onClick($event)">
      <!--ID-->
      <div *ngIf="settings?.columns?.id && !isCollapsed" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="sm">

        </bringoz-icon>
        <div class="flex layout-row"
             (mouseenter)="isShowCopyBtn=true"
             (mouseleave)="isShowCopyBtn=false">
          <span class="br-body-1 text-ellipsis">{{ route.id }}</span>
          <app-text-copy-button [isShowCopyBtn]="isShowCopyBtn"
                                [text]="route.id">
          </app-text-copy-button>
        </div>
      </div>

      <!--Time Window Row-->
      <div *ngIf="settings?.columns?.timeWindow && !isCollapsed" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="time-window-outline"
                      classSize="sm">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ dateRange | timeWindow }}</span>
      </div>

      <!--Duration Row-->
      <div *ngIf="settings?.columns?.duration && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="timer-outline"
                      classSize="sm"
                      [ngbTooltip]="'Duration' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals?.totalTimeSec | bringozTimeConvert }}</span>
      </div>

      <!--Agent Row-->
      <div *ngIf="settings?.columns?.agent && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="agent"
                      classSize="sm"
                      [ngbTooltip]="'Agent' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.resource?.agentName || '---' }}</span>
      </div>

      <!--Status Row-->
      <div *ngIf="settings?.columns?.status && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="status"
                      classSize="sm"
                      [ngbTooltip]="'Status' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-status-tag [status]="isRunning ? (route.actionProcess.isDispatching ? 'DISPATCHING' : 'OPTIMIZING') : route.status"></app-bringoz-status-tag>
      </div>

      <!--Skills Row-->
      <div *ngIf="settings?.columns?.skills && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="tag-outline"
                      classSize="sm"
                      [ngbTooltip]="'Skills' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!route.resource?.allocationSkills?.length" class="br-body-1 text-ellipsis">---</span>
        <app-skill-tags class="flex" [skillsIds]="route.resource?.allocationSkills" limit="1"></app-skill-tags>
      </div>

      <!--Labels Row-->
      <div *ngIf="settings?.columns?.labels && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="label-outline"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Labels' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-labels-display *ngIf="!!route.resource?.labels?.length"
                                    [labels]="route.resource.labels"
                                    maxItems="1">

        </app-bringoz-labels-display>
        <span *ngIf="!route.resource?.labels?.length" class="br-body-1 text-ellipsis">---</span>
      </div>

      <!--Vehicle Row-->
      <div *ngIf="settings?.columns?.vehicle && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon [iconName]="route.resource?.vehicleClass?.toLowerCase()"
                      [classSize]="'sm'"
                      [ngbTooltip]="'Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ logisticsVehicleName || route.resource?.vehicleName }}</span>
      </div>

      <!--Distance Row-->
      <div *ngIf="settings?.columns?.distance && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="distance"
                      [classSize]="'sm'"
                      [ngbTooltip]="'Total Distance' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals?.totalDistanceMeter | bringozDistance:'---':true }}</span>
      </div>

      <!--Distance Row-->
      <div *ngIf="settings?.columns?.carrier && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="carrier"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Carrier' | translate"
                      openDelay="300">

        </bringoz-icon>
        <app-bringoz-state-link *ngIf="!!route.resource?.carrierReference"
                                class="flex text-ellipsis"
                                [state]="'accounts-detail-supply.info.preferences'"
                                [permission]="'accounts.supply.get'"
                                [params]="{id: route.resource.carrierReference.id}"
                                [text]="route.resource.carrierReference.name">
        </app-bringoz-state-link>
        <span *ngIf="!route.resource?.carrierReference" class="br-body-1 text-ellipsis">---</span>

      </div>

      <!--Accounts Row-->
      <div *ngIf="settings?.columns?.accounts && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="account"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Accounts' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis"
              [ngbTooltip]="accountsTooltip"
              tooltipClass="planning-draft-routes-panel-list-item-accounts-tooltip"
              container="body">
        {{accountIds.length}}
      </span>

        <ng-template #accountsTooltip>
          <div class="layout-column" style="min-width: 400px;">
            <div class="flex layout-row">
              <div class="flex br-caption-1" style="text-align: start;">{{'Account Name' | translate}}:</div>
              <div class="flex br-caption-1" style="text-align: start;">{{'Address' | translate}}:</div>
              <div class="flex-30 br-caption-1" style="text-align: start;">{{'Account External ID' | translate}}:</div>
              <div class="flex-15 br-caption-1" style="text-align: start;">{{'Pallets' | translate}}:</div>
            </div>

            <div class="flex layout-row" *ngFor="let details of accountsDetails">
              <div class="flex" style="text-align: start;">
                {{details.name}}
              </div>

              <div class="flex layout-align-center-center text-ellipsis" style="text-align: start;">
                {{ details.address ? (details.address | bringozAddressCity) : '---'}}
              </div>

              <div class="flex-30 layout-align-center-center text-ellipsis" style="text-align: start;">
                {{details.externalId || '---' }}
              </div>

              <div class="flex-15 layout-row layout-align-start-center gap-5">
                {{details.pallets | number: '1.0-2'}}
                <bringoz-icon iconName="pallets" classSize="sm"></bringoz-icon>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <!--Account External ID Row-->
      <div *ngIf="settings?.columns?.accountExternalId && !isCollapsed"
           class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="hash"
                      classSize="sm">
        </bringoz-icon>
        <span *ngIf="!accountExternalIds?.length" class="br-body-1 text-ellipsis">---</span>
        <app-bringoz-items-list-display *ngIf="accountExternalIds?.length"
                                        [items]="accountExternalIds"
                                        [maxItems]="6">
        </app-bringoz-items-list-display>
      </div>

      <!--Picking Hour-->
      <div *ngIf="settings?.columns?.pickingHour && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="depot"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Picking Hour' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{pickingTime | bringozTime:'time' }}</span>
      </div>

      <!--Activities Count Row-->
      <div *ngIf="settings?.columns?.activitiesCount && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="location-pin-outline"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Stops' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!route.resource?.carrierReference" class="br-body-1 text-ellipsis">{{route.totals?.totalStopsCount}}</span>

      </div>


      <!--Load - Weight-->
      <div *ngIf="settings?.load?.weight && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="weight"
                      classSize="sm"
                      [ngbTooltip]="'Weight' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals.totalLoad | bringozWeight:true:'---' }}</span>
      </div>

      <!--Load - Volume-->
      <div *ngIf="settings?.load?.volume && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="volume"
                      classSize="sm"
                      [ngbTooltip]="'Volume' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals.totalVolume | bringozVolume: true:'---' }}</span>
      </div>

      <!--Load - Packages-->
      <div *ngIf="settings?.load?.packages && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="package-outline"
                      classSize="sm"
                      [ngbTooltip]="'Packages' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.totals.totalPackagesCount > 0; else emptyLoad"
              class="br-body-1 text-ellipsis">{{ (route.totals.totalPackagesCount === 1 ? 'X_PACKAGE' : 'X_PACKAGES') | translate: { sum: route.totals.totalPackagesCount } }}</span>
      </div>

      <!--Load - Value-->
      <div *ngIf="settings?.load?.value && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 ">
        <bringoz-icon iconName="dollar-circle"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Value' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ route.totals?.value | bringozPrice }}</span>
      </div>

      <!--Load - Pallets-->
      <div *ngIf="settings?.load?.pallets && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="pallets"
                      classSize="sm"
                      [ngbTooltip]="'Pallets' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.totals.totalPallets > 0; else emptyLoad"
              class="br-body-1 text-ellipsis">{{ (route.totals.totalPallets === 1 ? 'X_PALLET' : 'X_PALLETS') | translate: { sum: (route.totals.totalPallets | number: '1.0-2') } }}</span>
      </div>

      <!--Load - Spots-->
      <div *ngIf="settings?.load?.spots && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="spot"
                      classSize="sm"
                      [ngbTooltip]="'Spots' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="route.totals.totalSpots > 0; else emptyLoad"
              class="br-body-1 text-ellipsis">{{ route.totals.totalSpots === 1 ? 'X_SPOT' : 'X_SPOTS' | translate:{sum: route.totals.totalSpots} }}</span>
      </div>

      <ng-template #emptyLoad>
        <span class="br-body-1">---</span>
      </ng-template>

      <!--Load - Income-->
      <div *ngIf="settings?.columns?.income && !isCollapsed"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="dollar-circle"
                      classSize="sm"
                      [ngbTooltip]="'Income' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis route-total-income"
              [ngClass]="getTotalIncomeClass(route?.totals?.totalIncome)">{{ route?.totals?.totalIncome | bringozPrice: '---' }}</span>
      </div>

      <!--Weight Capacity Row-->
      <div
        *ngIf="(settings.capacity?.weight) && !isCollapsed"
        [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
        class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="weight"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Weight' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="this.route.resource.capacity.weight; else unlimitedWeight"
                                  [value]="(this.route.totals.totalLoad / this.route.resource.capacity.weight) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="weightTooltip">
        </app-bringoz-capacity-bar>

        <ng-template #weightTooltip>
        <span [ngClass]="weightSeverity">
          {{ (this.route.totals.totalLoad | number: '1.0-2') + (weightUnit | translate) + ' / ' }}
        </span>
          <span *ngIf="this.route.resource.capacity.weight" [ngClass]="weightSeverity">
          {{ (this.route.resource.capacity.weight | number: '1.0-2') + (weightUnit | translate) + ' = ' + ((this.route.totals.totalLoad / this.route.resource.capacity.weight) * 100 | number: '1.0-2') + '%' }}
        </span>
          <span *ngIf="!this.route.resource.capacity.weight" [ngClass]="weightSeverity">
          {{'UNLIMITED' | translate}}
        </span>
        </ng-template>

        <ng-template #unlimitedWeight>
          <div [ngbTooltip]="weightTooltip" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>


      <!--Volume Capacity Row-->
      <div
        *ngIf="(settings.capacity?.volume) && !isCollapsed"
        [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
        class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="volume"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Volume' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="volumeCapacity; else unlimitedVolume"
                                  [value]="(this.route.totals.totalVolume / volumeCapacity) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="volumeTooltip">
        </app-bringoz-capacity-bar>

        <ng-template #volumeTooltip>
        <span [ngClass]="volumeSeverity">
          {{ (this.route.totals.totalVolume | number: '1.0-2') + (volumeUnit | translate) + ' / ' }}
        </span>
          <span *ngIf="volumeCapacity" [ngClass]="volumeSeverity">
          {{ (volumeCapacity | number: '1.0-2') + (volumeUnit | translate) + ' = ' + ((this.route.totals.totalVolume / volumeCapacity) * 100 | number: '1.0-2') + '%' }}
        </span>
          <span *ngIf="!volumeCapacity" [ngClass]="volumeSeverity">
          {{'UNLIMITED' | translate}}
        </span>
        </ng-template>

        <ng-template #unlimitedVolume>
          <div [ngbTooltip]="volumeTooltip" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>

      <!--Pallets Capacity Row-->
      <div
        *ngIf="(settings.capacity?.pallets) && !isCollapsed"
        [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
        class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="pallets"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Pallets' | translate"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-capacity-bar *ngIf="this.route.resource.capacity.numberOfPallets; else unlimitedPallets"
                                  [value]="(this.route.totals.totalPallets / this.route.resource.capacity.numberOfPallets) * 100"
                                  [unit]="'%'"
                                  [severityThresholds]="severityThresholds"
                                  [showValue]="true"
                                  [ngbTooltip]="palletsTooltip">
        </app-bringoz-capacity-bar>

        <ng-template #palletsTooltip>
        <span [ngClass]="palletsSeverity">
          {{ (this.route.totals.totalPallets | number: '1.0-2') + ' / ' }}
        </span>
          <span *ngIf="this.route.resource.capacity.numberOfPallets" [ngClass]="palletsSeverity">
          {{ (this.route.resource.capacity.numberOfPallets | number: '1.0-2') + ' = ' + ((this.route.totals.totalPallets / this.route.resource.capacity.numberOfPallets) * 100 | number: '1.0-2') + '%' }}
        </span>
          <span *ngIf="!this.route.resource.capacity.numberOfPallets" [ngClass]="palletsSeverity">
          {{'UNLIMITED' | translate}}
        </span>
        </ng-template>

        <ng-template #unlimitedPallets>
          <div [ngbTooltip]="palletsTooltip" class="flex layout-row layout-align-start-center gap-5">
            <div class="unlimited-container layout-row layout-align-center-center">
              <span class="br-caption-1 font-weight-500">{{'UNLIMITED' | translate}}</span>
            </div>
            <bringoz-icon iconName="infinite"></bringoz-icon>
          </div>
        </ng-template>
      </div>
    </div>


  </div>

  <div *ngIf="(isHover) && canDrilldown"
       appBringozIdGenerator="open-side-route-drill-down-panel-route-routes-panel"
       class="drill-down-arrow full-height-arrow"
       (click)="onDrillDownClick($event);$event.stopPropagation()">
    <bringoz-icon iconName="arrow-right" classSize="lg" fill="#484848"></bringoz-icon>
  </div>

</div>
